// removed by extract-text-webpack-plugin
module.exports = {"sorting":"_1t80vcpOvrziA0tDiobVVs"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/Search/Customer/style.css
// module id = 2428
// module chunks = 0